import type { User } from "firebase/auth";
import { profileToGameArt } from "@/character/spritesheet";
import { loadCharacterProfile } from "@/character/storage";
import { HOME_ASSETS } from "@/home/home-assets";
import {
  CREATOR_SCENE_EDITOR_FEATURES,
  mountHomeSceneEditor,
} from "@/home/mount-home-scene-editor";
import {
  getCreatorSceneMeta,
  loadSceneRoom,
  saveSceneRoom,
} from "@/home/scene-room-storage";

export async function mountCreatorScenePage(
  root: HTMLElement,
  user: User,
  sceneId: string,
): Promise<() => void> {
  const profile = loadCharacterProfile(user.uid);
  if (!profile) {
    window.location.replace("/character/create");
    return () => {};
  }

  const meta = await getCreatorSceneMeta(user.uid, sceneId);
  if (!meta) {
    root.className = "page-shell page-creator";
    root.innerHTML = `
      <main class="auth-card">
        <h1>ไม่พบฉาก</h1>
        <p class="hint">ฉากนี้ถูกลบหรือลิงก์ไม่ถูกต้อง</p>
        <a class="btn btn-primary" href="/creator">กลับรายการฉาก</a>
      </main>
    `;
    return () => {};
  }

  const gameArt = profileToGameArt(profile);
  const avatarSrc = gameArt.playerIdleTextureUrl || HOME_ASSETS.avatarDefault;

  const handle = await mountHomeSceneEditor(root, {
    user,
    profile,
    profileName: profile.name,
    avatarSrc,
    gameArt,
    sceneId,
    hudSubtitle: meta.name,
    pageRootClass: "game-app page-my-home page-scene-creator",
    shell: "creator",
    features: CREATOR_SCENE_EDITOR_FEATURES,
    loadRoom: () => loadSceneRoom(user.uid, sceneId),
    saveRoom: (data) => saveSceneRoom(user.uid, sceneId, data),
  });
  return () => handle.destroy();
}
